export default {
  buttonTitle: {
    en: 'Login',
  },
}
